import ThirdPartyLoader from 'components/global/ThirdPartyLoader';
import { deepMerge } from 'toolbox/deepMerge';

/**
 * This is a description of the Insider constructor function.
 * @class
 * @classdesc This is a description of the Insider class. (must be edited)
 * @extends ThirdPartyLoader
 */
export default class Insider extends ThirdPartyLoader {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            url: null,
            event: {
                name: '',
            },
        }, options));
    }

    /**
    * On script load handler, called when the third-party is loaded
    * @param {Object} data - Response of the provider
    */
    onScriptLoaded(data) {
        this.state.loaded = true;
        this.state.loading = false;
        this.state.data = data;
        if (this.options.event.name === 'orderconfirmation') {
            window.insider_object = window.insider_object || {};
            window.insider_object.page = {
                type: 'Confirmation',
            };
        }

        if (this.options.userObject.isAuthenticated && this.options.userObject.isEnable) {
            const customobj = {
                points: this.options.userObject.points,
                membership: this.options.userObject.membership,
                birthday_month: this.options.userObject.birthday_month,
                first_purchase_date: this.options.userObject.first_purchase_date,
                first_purchase_amount: this.options.userObject.first_purchase_amount,
                total_purchase_amount: this.options.userObject.total_purchase_amount,
                point_expired_date: this.options.userObject.point_expired_date,
            };
            Object.keys(customobj).forEach(key => (customobj[key] == null) && delete customobj[key]);

            const userObject = {
                uuid: this.options.userObject.uuid,
                gdpr_optin: this.options.userObject.gdpr_optin,
                custom: customobj,
            };
            Object.keys(userObject).forEach(key => (userObject[key] == null) && delete userObject[key]);

            window.insider_object = window.insider_object || {};
            window.insider_object.user = userObject;
        }
    }
}
